<script lang="ts" setup>
import type { SizeVariants } from '~kui/types/kui';

interface Props {
  animated?: boolean;
  background?: 100 | 500 | 'white';
  size?: Extract<SizeVariants, 'sm' | 'md' | 'lg'>;
}

const props = withDefaults(defineProps<Props>(), {
  animated: true,
  background: 100,
  size: 'md',
});

const circleClasses = computed(() => {
  return (index: 1 | 2 | 3): string => {
    return twMerge(
      cva('rounded-full', {
        variants: {
          animated: {
            true: 'animate-bounce',
            false: '',
          },
          background: {
            100: 'bg-muted',
            500: 'bg-primary',
            white: 'bg-white',
          },
          size: {
            sm: 'size-2',
            md: 'size-3',
            lg: 'size-4',
          },
          index: {
            1: '[animation-delay:0.0s]',
            2: '[animation-delay:0.1s]',
            3: '[animation-delay:0.2s]',
          },
        },
      })({
        index,
        size: props.size,
        animated: props.animated,
        background: props.background,
      }),
    );
  };
});
</script>

<template>
  <div
    role="status"
    aria-live="polite"
    :aria-label="$t('unified.common.loadingContent')"
  >
    <div class="flex gap-2">
      <div
        v-for="i in 3"
        :key="i"
        :class="circleClasses(i as 1 | 2 | 3)"
        aria-hidden="true"
      />
    </div>
    <span class="sr-only hidden">{{ $t('unified.common.loadingContent') }}</span>
  </div>
</template>
